import React, {Dispatch, SetStateAction, useContext, useEffect} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import useCache from "../../hooks/useCache"
import Spinner from "../reusable/Spinner"
import TopSearches from "./TopSearches"
import SearchDesktopInitialContent from "./SearchDesktopInitialContent"
import SearchMobileInitialContent from "./SearchMobileInitialContent"

type Props = {
	setIsBackgroundOn?: Dispatch<SetStateAction<boolean>>
	isBackgroundOn?:boolean
	isBrandsPage?:boolean
}

const SearchContent: React.FC<Props> = ({setIsBackgroundOn, isBackgroundOn}) => {
	useEffect(() => {
		if (typeof document !== "undefined" && isBackgroundOn) {
			document.body.style.overflow = "hidden"
		} else if (!isBackgroundOn) {
			document.body.style.overflow = "auto"
		}

		return () => {
			document.body.style.overflow = "auto"
		}
	}, [isBackgroundOn])
	const {t} = useTranslation(["common"])
	const {data: topSearches, isLoading: isLoadingSuggestions} = useCache("/api/search/top-searches?limit=3", false, false, true)

	return (
		<section className="search-content bg-white "
			style={{width: "100%", overflowY: "auto", left: 0, zIndex: 90000, marginTop: 10, height: "80dvh"}}>
			<div className="container px-3 px-md-0">
				<div className="d-flex flex-column flex-md-row justify-content-center align-items-start align-items-md-center pt-3 pb-4 pb-md-5">
					<Typography variant="bodySmBold"
						className="me-3 mb-3 mb-md-0">{t("most-commonly-searched:")}</Typography>
					{isLoadingSuggestions ? <Spinner/> :
						<TopSearches topSearches={topSearches}
							forSearchContent
							setIsBackgroundOn={setIsBackgroundOn}/>}
				</div>
				<SearchDesktopInitialContent />
				{/* Mobile Version */}
				<SearchMobileInitialContent />
			</div>
		</section>
	)
}

export default React.memo(SearchContent)
